import React, {useState} from 'react';
import { View, Pressable } from 'react-native';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping } from '@fortawesome/free-solid-svg-icons';

import { Link } from 'app/src/utils/routing';
import { Text } from 'app/src/styles';
import * as colors from 'app/src/styles/colors';

const Container = styled(View)`
  flex-direction: row;
  column-gap: 10px;
  margin: 5px;
`;

const Name = styled(View)`
  width: 300px;
`;

const NameText = styled(Text)`
  font-weight: 600;
`;

const Detail = styled(View)`
  width: fit-content;
`;

const Result = ({ result }) => {
  return (
    <Container>
      <FontAwesomeIcon
        icon={faCartShopping}
        color="navy"
      />
      <Name>
        <NameText>
          {
            result.id === null ?
              `Create Buyer ${result.name}` :
              result.displayName
          }</NameText>
      </Name>
    </Container>
  );
};

const getResultLabel = (resultData) => {
  switch(resultData.__typename) {
    case 'Buyer':
      return resultData.fullDisplayName;
    default:
      break;
  }
}

const COMPONENT_MAP = {
  Buyer: Result,
};

const BuyerResult = ({ result, setTerm, clickedResult, setClickedResult,
  setShowNewBuyerModal, saleAsset, setSaleAssetId, updateSaleAsset,
  setDisplayResults
}) => {
  const ResultLink = COMPONENT_MAP[result.__typename];
  return (
    <View>
      <Pressable
        onPress={() => {
          if(result?.id !== null) {
            updateSaleAsset({
              variables: {
                id: saleAsset.id,
                offerAttributes: { buyerId: result.id }
              }
            });
            setTerm(result.name);
          }else {
            setSaleAssetId(saleAsset.id)
            setClickedResult(result);
            setShowNewBuyerModal(true);
            setTerm(result.name);
          }
        }}
        style={state => (
          { backgroundColor: state.hovered ? 'lightgray' : 'none' }
        )}
      >
        <ResultLink result={result} />
      </Pressable>
    </View>
  );
};

export default BuyerResult;
